import { FC, ReactNode } from "react";

interface ContainerHeaderProps {
  children: ReactNode; // Define children prop
  className?: string;
}

const ContainerHeader: FC<ContainerHeaderProps> = ({ children, className }) => {
  return (
    <h2
      className={`mb-4 text-xl font-semibold tracking-tight ${className ? className : ""}`}
    >
      {children}
    </h2>
  );
};

export default ContainerHeader;
